import React from 'react';
import { Descriptions, List } from '../../components';

export const SourceBasicInfo = ({ record, getStorageIcon }) => {
    const labelS = { width: 140 };
    const contentS = { paddingLeft: 12 };

    return (
        <Descriptions column={2} size="small" colon className="basic-info">
            <Descriptions.Item label="OS" styles={{ label: labelS, content: contentS }}>
                {record.os_version}
            </Descriptions.Item>
            <Descriptions.Item label="CPU" styles={{ label: labelS, content: contentS }}>
                {record.migrate_by_vm ? (
                    record.cpu_display
                ) : (
                    <List
                        size="small"
                        dataSource={Array.isArray(record.cpus) ? record.cpus : []}
                        locale={{ emptyText: record.cpu_display || 'N/A' }}
                        className="compact-list"
                        renderItem={(cpu) => <List.Item className="compact-item">{cpu.processor}</List.Item>}
                    />
                )}
            </Descriptions.Item>
            <Descriptions.Item label="Memory" styles={{ label: labelS, content: contentS }}>
                {record.memory}
            </Descriptions.Item>
            {record.migrate_by_vm ? (
                <Descriptions.Item label="VM Name" styles={{ label: labelS, content: contentS }}>
                    {record.vm_name}
                </Descriptions.Item>
            ) : (
                <Descriptions.Item label="Host Name" styles={{ label: labelS, content: contentS }}>
                    {record.hostname}
                </Descriptions.Item>
            )}
            {record.migrate_by_vm ? (
                <Descriptions.Item label="Disks" span={2} styles={{ label: labelS, content: contentS }}>
                    <List
                        size="small"
                        dataSource={record.disks || []}
                        className="compact-list"
                        renderItem={(disk) => (
                            <List.Item className="compact-item">
                                {`${disk.disk_label}, Size: ${disk.size} GiB, ${disk.disk_provisioning_type}`}
                            </List.Item>
                        )}
                    />
                </Descriptions.Item>
            ) : (
                <Descriptions.Item label="Mounts" span={2} styles={{ label: labelS, content: contentS }}>
                    {Array.isArray(record.mounts) ? (
                        <List
                            size="small"
                            dataSource={record.mounts}
                            className="compact-list mounts-list"
                            renderItem={(mount) => (
                                <List.Item className="compact-item">
                                    <span className="storage-icon">{getStorageIcon(mount.mount_name)}</span>
                                    {`${mount.mount_name} Size: ${mount.size} GiB, Free: ${mount.free} GiB`}
                                </List.Item>
                            )}
                        />
                    ) : (
                        'N/A'
                    )}
                </Descriptions.Item>
            )}
        </Descriptions>
    );
};

export default SourceBasicInfo;
